import arrowUp from '~/assets/icons/arrow_up_2.svg';
import toolbox from '~/assets/icons/toolbox.svg';
import { ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { CloseButton } from '~/components/ui/CloseButton';
import { Text } from '~/components/ui/Text';
import {
	StyledContainer,
	StyledLevelContainer,
	StyledRightContainer,
	StyledTitle,
} from './Head.styled';

const Head = () => {
	return (
		<StyledContainer>
			<StyledTitle>
				<img src={toolbox} />
				<Text>Крафтовый станок</Text>
			</StyledTitle>
			<StyledRightContainer>
				<StyledLevelContainer>
					<img src={arrowUp} />
					<Text>3 ур.</Text>
				</StyledLevelContainer>
				<CloseButton
					height={ButtonHeight.Height30}
					iconSize={14}
					color={ButtonColors.Default}
					onClick={() => {}}
				/>
			</StyledRightContainer>
		</StyledContainer>
	);
};

export { Head };
